var map = {
	"./Home/de": [
		68,
		7
	],
	"./Home/de.js": [
		68,
		7
	],
	"./Home/en": [
		69,
		6
	],
	"./Home/en.js": [
		69,
		6
	],
	"./Legal/de": [
		70,
		5
	],
	"./Legal/de.js": [
		70,
		5
	],
	"./Legal/en": [
		71,
		4
	],
	"./Legal/en.js": [
		71,
		4
	],
	"./Wizard/de": [
		72,
		1
	],
	"./Wizard/de.js": [
		72,
		1
	],
	"./Wizard/en": [
		73,
		0
	],
	"./Wizard/en.js": [
		73,
		0
	],
	"./de": [
		74,
		3
	],
	"./de.js": [
		74,
		3
	],
	"./en": [
		75,
		2
	],
	"./en.js": [
		75,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 156;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/content lazy ^\.\/.*$
// module id = 156
// module chunks = 8